// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"detail-module--titleContainer--dgvun","carousel":"detail-module--carousel--3Crq1","item":"detail-module--item--1wxbs","caption":"detail-module--caption--UGJ2d"};